import { getUA, isMobile } from 'react-device-detect';

import { DEVICE_TYPE } from '_constants/device';

export const getDeviceType = () => {
  return isMobile && !getUA.includes('Intel')
    ? DEVICE_TYPE.MOBILE
    : DEVICE_TYPE.DESKTOP;
};
